import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getTableData: {
        url: `${customerApi}/api/contact_ways`,
        type: 'GET',
    },

    deleteRecord: {
        url: `${customerApi}/api/contact_ways/{id}`,
        type: 'DELETE',
    },

    // 创建联系我
    createContactMe: {
        url: `${customerApi}/api/contact_ways`,
        type: 'POST',
    },

    // 编辑联系我
    editContactMe: {
        url: `${customerApi}/api/contact_ways/{id}`,
        type: 'PUT',
    },

    // 获取联系我详情
    getDetails: {
        url: `${customerApi}/api/contact_ways/{id}`,
        type: 'GET',
    },

    contactWaysExport: {
        url: `${customerApi}/api/contact_ways/export`,
        type: 'POST',
    },
}
